import { LazyOption, createLazyOption } from 'owa-options-core';
import { LazyModule } from 'owa-bundling';
var lazyFullModule = new LazyModule(() => import('./lazyFullOption'));
var lazyQuickModule = new LazyModule(() => import('./lazyQuickOption'));
let AppearanceOption: LazyOption = createLazyOption(
    {
        key: 'appearance',
        titleStringKey: 'optionTitle_appearance',
        searchTermsStringKey: 'optionSearch_appearance',
        allowedOptionKeys: ['CalendarAppearance'],
    },
    lazyFullModule,
    m => m.default,
    lazyQuickModule,
    m => m.default
);
export default AppearanceOption;
